<mat-form-field style="margin-left: 15px; max-width: 180px">
  <mat-label class="filter-text">Show me</mat-label>
  <mat-select class="filter-text" [value]="filterVisibility" (selectionChange)="filterChanged($event.value)" name="visibility">
    <mat-option value="-">All</mat-option>
    <mat-option value="favourite">Favourite</mat-option>
    <mat-option value="shared">Shared</mat-option>
  </mat-select>
</mat-form-field>
